// removed by extract-text-webpack-plugin
module.exports = {"complaint-wrap":"complaint-wrap","complaint-info-wrap":"complaint-info-wrap","user-name":"user-name","user-type":"user-type","complaint-line":"complaint-line","complaint-content":"complaint-content","feedback-wrap":"feedback-wrap","feedback-input":"feedback-input","feedback-button":"feedback-button","update-btn":"update-btn"};


//////////////////
// WEBPACK FOOTER
// ./components/users/sub-view/complaint-detail-content/_ComplaintDetailContent.scss
// module id = ./components/users/sub-view/complaint-detail-content/_ComplaintDetailContent.scss
// module chunks = 0